// 戒托筛选Vue组件
const RingFilterApp = {
    delimiters: ['[[', ']]'],
    data() {
      return {
        msg: "ring holder",
        total: 0,
        list: [],
        diamond_variant_id: "",
        handle: "",
        filters: {},
        sortBy: "best_seller",
        sortByMethod: "desc",
        debug: true,
        // 保存上一次筛选后的数据，防止重置
        lastFilteredList: [],
        // 检测是否正在移除筛选条件
        isRemovingFilter: false,
        // 加载状态
        isLoading: false,
        // 价格范围
        priceRange: {
          min: 310,
          max: 10000,
          currentMin: 310,
          currentMax: 10000
        }
      }
    },
    created() {
      this.diamond_variant_id = this.getUrlParams("diamond_variant");
      this.handle = this.getUrlParams("handle");
      
      console.log("初始化RingFilterApp", {
        diamond_variant_id: this.diamond_variant_id,
        handle: this.handle
      });
      
      // 初始加载 - 不带筛选条件
      this.initDataWithoutFilters();
      
      // 让vm实例全局可用，便于DOM事件调用
      window.vm = this;
    },
    mounted() {
      console.log("RingFilterApp已挂载");
      
      // 监听筛选事件，用于调试
      window.addEventListener('beforeunload', () => {
        console.log("页面即将卸载，当前筛选条件:", this.filters);
      });
      
      // 初始化时确保UI状态正确
      this.$nextTick(() => {
        this.updateFilterOptionsUI();
        
        // 查找并移除格式为"key: value"的标签
        const allTags = document.querySelectorAll('.filter-tag');
        allTags.forEach(tag => {
          const text = tag.textContent.trim();
          if (text.includes(': ')) {
            tag.remove();
          }
        });
        
        // 确保DOM已完全加载后初始化价格滑块
        setTimeout(() => {
          console.log("延迟后初始化价格滑块");
          this.initPriceSlider();
        }, 500);
      });
    },
    methods: {
      // 初始化价格滑块
      initPriceSlider() {
        console.log('开始初始化价格滑块');
        const minSlider = document.getElementById('price_min');
        const maxSlider = document.getElementById('price_max');
        const minValue = document.getElementById('price_min_value');
        const maxValue = document.getElementById('price_max_value');
        const track = document.getElementById('price_track');
        
        if (!minSlider || !maxSlider) {
          console.error('找不到价格滑块元素', { 
            minSlider: minSlider ? '存在' : '不存在', 
            maxSlider: maxSlider ? '存在' : '不存在' 
          });
          
          // 如果元素不存在，尝试再次延迟加载
          setTimeout(() => {
            console.log('再次尝试初始化价格滑块');
            this.initPriceSlider();
          }, 500);
          return;
        }
        
        // 设置初始值
        this.priceRange.min = parseInt(minSlider.getAttribute('min') || 310);
        this.priceRange.max = parseInt(maxSlider.getAttribute('max') || 10000);
        this.priceRange.currentMin = parseInt(minSlider.value);
        this.priceRange.currentMax = parseInt(maxSlider.value);
        
        console.log('价格滑块初始值', this.priceRange);
        
        // 清除可能存在的旧事件监听器
        const cloneMin = minSlider.cloneNode(true);
        const cloneMax = maxSlider.cloneNode(true);
        
        minSlider.parentNode.replaceChild(cloneMin, minSlider);
        maxSlider.parentNode.replaceChild(cloneMax, maxSlider);
        
        // 获取新的引用
        const newMinSlider = document.getElementById('price_min');
        const newMaxSlider = document.getElementById('price_max');
        
        // 为最小值滑块添加事件
        newMinSlider.addEventListener('input', () => {
          const min = parseInt(newMinSlider.value);
          const max = parseInt(newMaxSlider.value);
          
          console.log(`最小价格滑块移动: ${min}`);
          
          // 确保最小值不超过最大值
          if (min > max) {
            newMinSlider.value = max;
            this.priceRange.currentMin = max;
          } else {
            this.priceRange.currentMin = min;
          }
          
          // 更新显示值
          if (minValue) {
            minValue.textContent = '$' + this.formatPrice(this.priceRange.currentMin);
          }
          
          // 更新滑块轨道
          this.updatePriceTrack(track, newMinSlider, newMaxSlider);
        });
        
        // 最小值滑块松开时应用筛选
        newMinSlider.addEventListener('change', () => {
          console.log('最小价格滑块变化完成');
          this.applyPriceFilter();
        });
        
        // 为最大值滑块添加事件
        newMaxSlider.addEventListener('input', () => {
          const min = parseInt(newMinSlider.value);
          const max = parseInt(newMaxSlider.value);
          
          console.log(`最大价格滑块移动: ${max}`);
          
          // 确保最大值不小于最小值
          if (max < min) {
            newMaxSlider.value = min;
            this.priceRange.currentMax = min;
          } else {
            this.priceRange.currentMax = max;
          }
          
          // 更新显示值
          if (maxValue) {
            maxValue.textContent = '$' + this.formatPrice(this.priceRange.currentMax);
          }
          
          // 更新滑块轨道
          this.updatePriceTrack(track, newMinSlider, newMaxSlider);
        });
        
        // 最大值滑块松开时应用筛选
        newMaxSlider.addEventListener('change', () => {
          console.log('最大价格滑块变化完成');
          this.applyPriceFilter();
        });
        
        // 初始设置显示值
        if (minValue) minValue.textContent = '$' + this.formatPrice(this.priceRange.currentMin);
        if (maxValue) maxValue.textContent = '$' + this.formatPrice(this.priceRange.currentMax);
        
        // 初始设置轨道背景
        this.updatePriceTrack(track, newMinSlider, newMaxSlider);
        
        console.log('价格滑块初始化完成');
      },
      
      // 更新价格滑块轨道背景
      updatePriceTrack(track, minSlider, maxSlider) {
        if (!track || !minSlider || !maxSlider) {
          console.error('更新轨道时缺少必要元素', {
            track: track ? '存在' : '不存在',
            minSlider: minSlider ? '存在' : '不存在',
            maxSlider: maxSlider ? '存在' : '不存在'
          });
          return;
        }
        
        const min = parseInt(minSlider.value);
        const max = parseInt(maxSlider.value);
        const minPos = ((min - this.priceRange.min) / (this.priceRange.max - this.priceRange.min)) * 100;
        const maxPos = ((max - this.priceRange.min) / (this.priceRange.max - this.priceRange.min)) * 100;
        
        track.style.background = `linear-gradient(to right, #ddd 0%, #2F4F4F ${minPos}%, #2F4F4F ${maxPos}%, #ddd ${maxPos}%)`;
        console.log(`更新价格轨道: ${minPos}% - ${maxPos}%`);
      },
      
      // 格式化价格显示
      formatPrice(price) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      
      // 应用价格筛选
      applyPriceFilter() {
        const min = this.priceRange.currentMin;
        const max = this.priceRange.currentMax;
        
        console.log(`应用价格筛选: $${min} - $${max}`);
        
        // 只有当价格范围不是默认的时候才添加筛选条件
        if (min > this.priceRange.min || max < this.priceRange.max) {
          // 添加价格筛选条件
          this.filters.min_price = min;
          this.filters.max_price = max;
          
          // 创建价格标签文本
          this.filters.price_display = `$${this.formatPrice(min)} - $${this.formatPrice(max)}`;
          
          console.log("已应用价格筛选:", JSON.stringify({
            min_price: this.filters.min_price,
            max_price: this.filters.max_price,
            display: this.filters.price_display
          }));
        } else {
          // 如果是默认范围，移除价格筛选条件
          delete this.filters.min_price;
          delete this.filters.max_price;
          delete this.filters.price_display;
          console.log("价格筛选已重置为默认值");
        }
        
        // 重新加载数据
        this.initData();
        
        // 更新活跃筛选标签
        this.updateActiveFilters();
      },
      
      // 重置价格筛选
      resetPriceFilter() {
        console.log("重置价格筛选");
        
        // 重置价格滑块的值
        const minSlider = document.getElementById('price_min');
        const maxSlider = document.getElementById('price_max');
        const minValue = document.getElementById('price_min_value');
        const maxValue = document.getElementById('price_max_value');
        const track = document.getElementById('price_track');
        
        if (minSlider && maxSlider) {
          minSlider.value = this.priceRange.min;
          maxSlider.value = this.priceRange.max;
          
          this.priceRange.currentMin = this.priceRange.min;
          this.priceRange.currentMax = this.priceRange.max;
          
          if (minValue) minValue.textContent = '$' + this.formatPrice(this.priceRange.min);
          if (maxValue) maxValue.textContent = '$' + this.formatPrice(this.priceRange.max);
          
          // 更新轨道背景
          this.updatePriceTrack(track, minSlider, maxSlider);
        }
        
        // 移除价格筛选条件
        delete this.filters.min_price;
        delete this.filters.max_price;
        delete this.filters.price_display;
      },
      
      // 不使用筛选条件初始化数据 - 只在最初加载时使用
      async initDataWithoutFilters() {
        console.log("初始化数据，无筛选条件");
        this.isLoading = true;
        
        if (!this.diamond_variant_id) {
          console.error('缺少diamond_variant_id参数，无法加载数据');
          this.isLoading = false;
          return;
        }
        
        // 添加step=ring参数
        let url = `${main_api_url}/api/search?diamond_variant_id=${this.diamond_variant_id}&order_by=${this.sortBy}&order_method=${this.sortByMethod}&step=ring`;
        console.log("初始API URL:", url);
        
        try {
          let response = await fetch(url);
          const {data, code} = await response.json();
          if (code == 1) {
            this.total = data.total;
            const list = data.data;
            list.forEach((item) => {
              item.link = `/products/${item.spu_handle}?variant=${item.sku_id}&diamond_variant=${this.diamond_variant_id}`;
              item.variation_products.forEach((variation)=>{
                variation.color_style_value = variation.variation_value.replaceAll(' ','_');
                variation.selected = variation.id == item.spu_id?'is-selected':'';
                
                variation.link = `/products/${variation.handle}?variant=${variation.id}&diamond_variant=${this.diamond_variant_id}&handle=${this.handle}`;
              })
            });
            console.log(list);
            this.list = list;
            // 保存为最后筛选结果
            this.lastFilteredList = [...list];
            console.log(`初始产品列表加载成功，共${list.length}个产品`);
            
            // 更新筛选标签
            this.updateActiveFilters();
          }
        } catch (error) {
          console.error("获取初始数据失败:", error);
        } finally {
          this.isLoading = false;
        }
      },
      
      // 使用筛选条件加载数据
      async initData() {
        console.log("使用筛选条件初始化数据，筛选条件:", JSON.stringify(this.filters));
        this.isLoading = true;
        
        if (!this.diamond_variant_id) {
          console.error('缺少diamond_variant_id参数，无法加载数据');
          this.isLoading = false;
          return;
        }
        
        // 判断是否存在有效的筛选条件
        const hasValidFilters = Object.keys(this.filters).some(key => 
          !['price_display'].includes(key) // 排除仅用于显示的字段
        );
        
        // 如果没有筛选条件，无论是否正在移除筛选条件，都重新加载所有产品
        if (!hasValidFilters) {
          console.log("没有筛选条件，加载所有产品");
          
          // 直接调用不带筛选条件的初始化方法
          await this.initDataWithoutFilters();
          return;
        }
        
        // 添加step=ring参数
        let url = `${main_api_url}/api/search?diamond_variant_id=${this.diamond_variant_id}&step=ring`;
        // 添加筛选参数
        for (const [key, value] of Object.entries(this.filters)) {
          // 跳过仅用于显示的字段
          if (key === 'price_display') continue;
          // 对于shape使用shapes参数（API变更）
          if (key === 'shape' && Array.isArray(value) && value.length > 0) {
            // 过滤掉null值，然后用逗号连接
            const validShapes = value.filter(shape => shape !== null && shape !== 'null');
            if (validShapes.length > 0) {
              // 使用shapes作为参数名 - 适应API变化
              url += `&shapes=${encodeURIComponent(validShapes.join(','))}`;
            }
          }else if (key === 'style' && Array.isArray(value) && value.length > 0) {
            // 过滤掉null值，然后用逗号连接
            const validStyles = value.filter(style => style !== null && style !== 'null');
            if (validStyles.length > 0) {
              // 使用styles作为参数名 - 适应API变化
              url += `&styles=${encodeURIComponent(validStyles.join(','))}`;
            }
          } else {
            // 其他筛选条件，排除null值
            if (value !== null && value !== 'null') {
              url += `&${key}=${encodeURIComponent(value)}`;
            }
          }
        }
        
        // 添加排序参数
        if (this.sortBy) {
          url += `&order_by=${this.sortBy}&order_method=${this.sortByMethod}`;
        }
        
        console.log("筛选API URL:", url);
        console.log("是否有筛选条件:", hasValidFilters);
        
        try {
          let response = await fetch(url);
          const {data, code} = await response.json();
          if (code == 1) {
            this.total = data.total;
            const list = data.data;
            list.forEach((item) => {
              item.link = `/products/${item.spu_handle}?variant=${item.sku_id}&diamond_variant=${this.diamond_variant_id}`;
              item.variation_products.forEach((variation)=>{
                variation.color_style_value = variation.variation_value.replaceAll(' ','_');
                variation.selected = variation.id == item.spu_id?'is-selected':'';
                
                variation.link = `/products/${variation.handle}?variant=${variation.id}&diamond_variant=${this.diamond_variant_id}&handle=${this.handle}`;
              })
            });
            console.log(list);
            this.list = list;
            
            // 保存为最后筛选结果
            this.lastFilteredList = [...list];
            
            console.log(`筛选后产品列表，共${list.length}个产品`);
            
            // 数据加载后更新UI状态
            this.updateActiveFilters();
            this.updateFilterOptionsUI();
          } else {
            console.error("API返回错误:", data);
          }
        } catch (error) {
          console.error("获取筛选数据失败:", error);
        } finally {
          this.isLoading = false;
        }
      },
      
      getUrlParams(key) {
        try {
          const searchParams = new URLSearchParams(location.href.split('?')[1]);
          const params = {};
      
          for (const [key, value] of searchParams.entries()) {
            params[key] = value;
          }
      
          return key in params ? params[key] : '';
        } catch(e) {
          return "";
        }
      },
      
      // 应用筛选条件
      applyFilter(key, value) {
        if (this.isLoading) {
          console.log("正在加载数据，忽略筛选操作");
          return;
        }
        
        console.log(`应用筛选: ${key} = ${value}`);
        
        // 忽略null值
        if (value === null || value === 'null') {
          console.log('忽略null值筛选');
          return;
        }
        
        // 重置移除筛选状态
        this.isRemovingFilter = false;
        
        // 对shape进行特殊处理，实现叠加筛选
        if (key === 'shape' || key === 'style') {
          // 确保filters中有shape键且是数组
          if (!this.filters[key]) {
            this.filters[key] = [];
          } else if (!Array.isArray(this.filters[key])) {
            // 如果之前不是数组格式，转换为数组
            this.filters[key] = [this.filters[key]];
          }
          
          // 检查是否已经包含该值
          const index = this.filters[key].indexOf(value);
          if (index === -1) {
            // 如果不包含，添加它
            this.filters[key].push(value);
            console.log(`添加${key}值: ${value}, 当前shape列表:`, this.filters[key]);
          } else {
            // 如果已包含，移除它
            this.isRemovingFilter = true;
            this.filters[key].splice(index, 1);
            console.log(`移除${key}值: ${value}, 当前shape列表:`, this.filters[key]);
            
            // 如果数组为空，则删除该筛选条件，但不重置
            if (this.filters[key].length === 0) {
              delete this.filters[key];
              console.log("shape列表为空，移除shape筛选条件");
            }
          }
        } else {
          // 检查是否已经应用了该筛选条件且值相同
          if (this.filters[key] === value) {
            // 如果已应用且值相同，则移除该筛选条件，但不重置
            this.isRemovingFilter = true;
            delete this.filters[key];
            console.log(`移除筛选条件: ${key}`);
          } else {
            // 否则设置该筛选条件
            this.filters[key] = value;
            console.log(`设置筛选条件: ${key} = ${value}`);
          }
        }
        
        console.log("当前所有筛选条件:", JSON.stringify(this.filters));
        
        // 无论是否有筛选条件，都直接获取数据
        this.initData();
        
        // 更新筛选选项的UI状态
        this.updateFilterOptionsUI();
      },
      
      // 更新筛选选项的UI状态
      updateFilterOptionsUI() {
        console.log("更新筛选选项UI:", JSON.stringify(this.filters));
        
        // 先清除所有选项的active状态
        const allFilterOptions = document.querySelectorAll('.js_filter_option');
        allFilterOptions.forEach(option => {
          option.classList.remove('active');
        });
        
        // 更新shape筛选选项的UI状态
        const shapeOptions = document.querySelectorAll('[data-filter_name="shape"]');
        shapeOptions.forEach(option => {
          const value = option.getAttribute('data-text');
          if (this.filters.shape && Array.isArray(this.filters.shape) && this.filters.shape.includes(value)) {
            option.classList.add('active');
          }
        });
        const styleOptions = document.querySelectorAll('[data-filter_name="style"]');
        styleOptions.forEach(option => {
          const value = option.getAttribute('data-text');
          if (this.filters.style && Array.isArray(this.filters.style) && this.filters.style.includes(value)) {
            option.classList.add('active');
          }
        });
        
        // 更新其他筛选选项的UI状态
        for (const key in this.filters) {
          if (key !== 'shape' && key !== 'min_price' && key !== 'max_price' && key !== 'price_display') {
            const options = document.querySelectorAll(`[data-filter_name="${key}"]`);
            options.forEach(option => {
              if (option.getAttribute('data-text') === this.filters[key]) {
                option.classList.add('active');
              }
            });
          }
        }
      },
      
      // 移除筛选条件
      removeFilter(key, value) {
        if (this.isLoading) {
          console.log("正在加载数据，忽略移除操作");
          return;
        }
        
        console.log(`移除筛选: ${key}, 值: ${value}`);
        this.isRemovingFilter = true;
        
        // 特殊处理价格筛选
        if (key === 'price') {
          this.resetPriceFilter();
          
          // 重新加载数据
          this.initData();
          return;
        }
        
        if ((key === 'shape'|| key == 'style') && Array.isArray(this.filters[key])) {
          // 对于shape，移除特定值
          if (value !== undefined) {
            const index = this.filters[key].indexOf(value);
            if (index !== -1) {
              this.filters[key].splice(index, 1);
              console.log(`从shape数组中移除: ${value}`);
            }
            
            // 如果数组为空，则完全删除该筛选条件
            if (this.filters[key].length === 0) {
              delete this.filters[key];
              console.log("shape数组为空，移除shape筛选条件");
            }
          } else {
            // 如果没有提供value，则删除整个shape筛选
            delete this.filters[key];
            console.log("移除整个shape筛选条件");
          }
        } else {
          // 其他筛选条件直接删除
          delete this.filters[key];
          console.log(`移除筛选条件: ${key}`);
        }
        
        console.log("移除后筛选条件:", JSON.stringify(this.filters));
        
        // 无论是否还有筛选条件，都使用initData加载数据
        this.initData();
        
        // 更新筛选选项的UI状态
        this.updateFilterOptionsUI();
      },
      
      // 重置所有筛选条件
      resetAllFilters() {
        console.log('重置所有筛选条件');
        
        // 清空所有筛选条件
        this.filters = {};
        this.isRemovingFilter = false;
        
        // 重置价格滑块
        this.resetPriceFilter();
        
        // 使用初始加载方法重新获取数据
        this.initDataWithoutFilters();
        
        // 更新筛选选项的UI状态
        this.updateFilterOptionsUI();
        
        // 额外强制更新一次活跃的筛选标签
        this.updateActiveFilters();
        
        console.log('已重置所有筛选条件，当前筛选条件:', this.filters);
      },
      
      // 应用排序
      applySort(sortValue,sortMethod) {
        console.log(`应用排序: ${sortValue} ${sortMethod}`);
        this.sortBy = sortValue;
        this.sortByMethod = sortMethod;
        
        // 根据是否有筛选条件选择不同的初始化方法
        this.initData();
      },
      
      // 更新筛选标签显示
      updateActiveFilters() {
        console.log("更新筛选标签:", JSON.stringify(this.filters));
        
        // 找到两个筛选标签容器
        const filterTagsContainer1 = document.querySelector('.active-filters');
        const filterTagsContainer2 = document.querySelector('.active-filters-secondary'); // 第二个容器
        
        if (!filterTagsContainer1 && !filterTagsContainer2) {
          console.error('筛选标签容器不存在，请确保HTML中至少有一个筛选标签容器');
          return;
        }
        
        // 清空现有标签
        if (filterTagsContainer1) filterTagsContainer1.innerHTML = '';
        if (filterTagsContainer2) filterTagsContainer2.innerHTML = '';
        
        // 标记是否有筛选条件
        let hasFilters = false;
        
        // 为每个筛选条件创建标签，在两个容器中都添加
        for (const [key, value] of Object.entries(this.filters)) {
          // 跳过仅用于显示的字段
          if (key === 'min_price' || key === 'max_price') continue;
          
          hasFilters = true;
          
          if (key === 'shape' && Array.isArray(value)) {
            // 对于shape数组，为每个值创建一个单独的标签
            value.forEach(shapeValue => {
              // 跳过null值
              if (shapeValue === null || shapeValue === 'null') {
                return;
              }
              
              const displayText = this.getDisplayTextForValue('shape', shapeValue);
              // 跳过No Shape选项
              if (displayText === 'No Shape' || displayText === 'None') {
                return;
              }
              
              // 在第一个容器中创建标签
              if (filterTagsContainer1) {
                this.createSingleFilterTag(filterTagsContainer1, 'shape', shapeValue, displayText);
              }
              
              // 在第二个容器中创建相同的标签
              if (filterTagsContainer2) {
                this.createSingleFilterTag(filterTagsContainer2, 'shape', shapeValue, displayText);
              }
            });
          }else if (key === 'style' && Array.isArray(value)) {
            // 对于style数组，为每个值创建一个单独的标签
            value.forEach(styleValue => {
              // 跳过null值
              if (styleValue === null || styleValue === 'null') {
                return;
              }
              
              const displayText = this.getDisplayTextForValue('style', styleValue);
              // 跳过No Shape选项
              if (displayText === 'No Style' || displayText === 'None') {
                return;
              }
              
              // 在第一个容器中创建标签
              if (filterTagsContainer1) {
                this.createSingleFilterTag(filterTagsContainer1, 'style', styleValue, displayText);
              }
              
              // 在第二个容器中创建相同的标签
              if (filterTagsContainer2) {
                this.createSingleFilterTag(filterTagsContainer2, 'style', styleValue, displayText);
              }
            });
          } else if (key === 'price_display') {
            // 为价格筛选创建特殊标签
            const displayText = value;
            
            // 在第一个容器中创建标签
            if (filterTagsContainer1) {
              this.createSingleFilterTag(filterTagsContainer1, 'price', null, displayText);
            }
            
            // 在第二个容器中创建相同的标签
            if (filterTagsContainer2) {
              this.createSingleFilterTag(filterTagsContainer2, 'price', null, displayText);
            }
          } else {
            // 跳过null值
            if (value === null || value === 'null') {
              continue;
            }
            
            const displayText = this.getDisplayTextForValue(key, value);
            // 跳过No选项
            if (displayText.startsWith('No ') || displayText === 'None') {
              continue;
            }
            
            // 在第一个容器中创建标签
            if (filterTagsContainer1) {
              this.createSingleFilterTag(filterTagsContainer1, key, value, displayText);
            }
            
            // 在第二个容器中创建相同的标签
            if (filterTagsContainer2) {
              this.createSingleFilterTag(filterTagsContainer2, key, value, displayText);
            }
          }
        }
        
        // 如果有筛选条件，添加"Reset All"按钮到两个容器
        if (hasFilters) {
          if (filterTagsContainer1) {
            const resetAllTag1 = document.createElement('span');
            resetAllTag1.className = 'filter-tag reset-all';
            resetAllTag1.innerHTML = 'Reset All <span class="remove-filter">×</span>';
            resetAllTag1.addEventListener('click', () => this.resetAllFilters());
            filterTagsContainer1.appendChild(resetAllTag1);
            
            // 显示容器
            filterTagsContainer1.style.display = 'flex';
          }
          
          if (filterTagsContainer2) {
            const resetAllTag2 = document.createElement('span');
            resetAllTag2.className = 'filter-tag reset-all';
            resetAllTag2.innerHTML = 'Reset All <span class="remove-filter">×</span>';
            resetAllTag2.addEventListener('click', () => this.resetAllFilters());
            filterTagsContainer2.appendChild(resetAllTag2);
            
            // 显示容器
            filterTagsContainer2.style.display = 'flex';
          }
          
          console.log("显示筛选标签容器，有活跃筛选条件");
        } else {
          // 隐藏容器
          if (filterTagsContainer1) filterTagsContainer1.style.display = 'none';
          if (filterTagsContainer2) filterTagsContainer2.style.display = 'flex';
          
          console.log("显示筛选标签容器，有活跃筛选条件");
        } 
      },
      
      // 创建单个筛选标签
      createSingleFilterTag(container, key, value, displayText) {
        // 跳过null值和No开头的显示文本（除了价格）
        if ((value === null || value === 'null') && key !== 'price') {
          return null;
        }
        
        if (displayText.startsWith('No ') || displayText === 'None') {
          return null;
        }
        
        // 创建标签元素
        const tag = document.createElement('span');
        tag.className = 'filter-tag';
        tag.setAttribute('data-filter-key', key);
        if (value !== null) {
          tag.setAttribute('data-filter-value', value);
        }
        
        // 使用pure显示文本，不包含key前缀
        tag.innerHTML = `${displayText} <span class="remove-filter">×</span>`;
        
        // 整个标签都可以点击删除
        tag.style.cursor = 'pointer';
        tag.title = '点击删除此筛选条件';
        
        // 为整个标签添加点击事件（直接移除筛选）
        tag.addEventListener('click', () => {
          console.log(`点击筛选标签: ${key} = ${value}`);
          this.removeFilter(key, value);
        });
        
        // 添加到容器
        container.appendChild(tag);
        console.log(`创建筛选标签: ${key} = ${value} (${displayText})`);
        return tag;
      },
      
      // 获取筛选值的显示文本
      getDisplayTextForValue(key, value) {
        // 如果是null值，返回对应的提示
        if (value === null || value === 'null') {
          return `No ${key.charAt(0).toUpperCase() + key.slice(1)}`;
        }
        
        // 根据您的需求映射值到显示文本
        const mappings = {
          'metal': {
            'Yellow Gold': 'Yellow Gold',
            'White Gold': 'White Gold',
            'Rose Gold': 'Rose Gold',
            'Platinum': 'Platinum',
            'null': 'No Metal'
          },
          'shape': {
            'Round': 'Round',
            'Oval': 'Oval',
             'null': 'No Shape'
          },
          'style': {
            'Hidden Halo': 'Hidden Halo',
            'Three Stone': 'Three Stone',
            'Nature Inspired': 'Nature Inspired',
            'Halo': 'Halo',
            'accent': 'Accents',
            'solitaire': 'Solitaire',
            'halo': 'Halo',
            'three-stone': 'Three Stone',
            'vintage': 'Vintage'
          }
        };
        
        // 检查是否有映射
        if (mappings[key] && mappings[key][value]) {
          return mappings[key][value];
        }
        
        // 对于字符串值，返回原值
        return value;
      }
    }
  };
  
  // 当DOM加载完成后初始化Vue应用
  document.addEventListener('DOMContentLoaded', function() {
    // 初始化Vue应用
    if (document.getElementById('ring-filter-app')) {
      window.vm = Vue.createApp(RingFilterApp).mount('#ring-filter-app');
      console.log("Vue应用已初始化并挂载");
      
      // 获取所有筛选选项
      const filterOptions = document.querySelectorAll('.js_filter_option');
      
      // 为每个选项添加点击事件
      filterOptions.forEach(option => {
        option.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation(); // 阻止事件冒泡
          
          const filterName = this.getAttribute('data-filter_name');
          const filterValue = this.getAttribute('data-text');
          
          console.log(`点击筛选选项: ${filterName} = ${filterValue}`);
          
          // 如果Vue实例存在，调用筛选方法
          if (window.vm && !window.vm.isLoading) {
            window.vm.applyFilter(filterName, filterValue);
          } else {
            console.log("Vue实例不可用或正在加载数据，忽略点击事件");
          }
          
          return false; // 防止默认行为
        });
      });
      
      // 添加排序选项点击事件
      const sortOptions = document.querySelectorAll('.sort-option');
      sortOptions.forEach(option => {
        option.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          let sortValue = this.getAttribute('data-value');
          let sortMethod = this.getAttribute('data-method');
          console.log("sortMethos",sortMethod);
          document.querySelector('.js-sort_result').textContent = this.textContent.trim();
          
          // 更新活跃状态
          sortOptions.forEach(opt => opt.classList.remove('active'));
          this.classList.add('active');
          
          // 调用Vue实例的排序方法
          if (window.vm && !window.vm.isLoading) {
            window.vm.applySort(sortValue,sortMethod);
          }
          
          return false;
        });
      });
      
      // 等待DOM完全加载，确保价格滑块初始化
      setTimeout(() => {
        if (window.vm && typeof window.vm.initPriceSlider === 'function') {
          console.log("DOMContentLoaded后延迟初始化价格滑块");
          window.vm.initPriceSlider();
        }
      }, 800);
    }
  });

  // 单独的价格滑块初始化，以防Vue初始化中的初始化失败
  window.addEventListener('load', function() {
    setTimeout(() => {
      if (window.vm && document.getElementById('price_min') && document.getElementById('price_max')) {
        console.log("window.load事件后重新尝试初始化价格滑块");
        window.vm.initPriceSlider();
      }
    }, 1000);
  });